import { render, staticRenderFns } from "./LvPdfViewer.vue?vue&type=template&id=6ab54348"
import script from "./LvPdfViewer.vue?vue&type=script&lang=js"
export * from "./LvPdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports